export type ValidatorRule =
  | 'required'
  | 'email'
  | 'username'
  | 'numeric'
  | { minLength: number }
  | { maxLength: number };

export function handleValidation(
  inputValue: string,
  validators: ValidatorRule[] | undefined,
  setErrorMessage: (msg: string) => void,
  setInputError: (label: string, hasError: boolean) => void,
  label: string,
): boolean {
  for (const rule of validators || []) {
    if (rule === 'required' && !inputValue.trim()) {
      setErrorMessage('This field is required');
      setInputError(label, true);
      return false;
    }
    if (rule === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputValue)) {
      setErrorMessage('Must be a valid email');
      setInputError(label, true);
      return false;
    }
    if (rule === 'username' && !/^[a-zA-Z0-9_]+$/.test(inputValue)) {
      setErrorMessage('Only letters, numbers, and underscores');
      setInputError(label, true);
      return false;
    }
    if (rule === 'numeric' && !/^\d+$/.test(inputValue)) {
      setErrorMessage('Only numbers allowed');
      setInputError(label, true);
      return false;
    }
    if (
      typeof rule === 'object' &&
      'minLength' in rule &&
      inputValue.length < rule.minLength
    ) {
      setErrorMessage(`Minimum length is ${rule.minLength}`);
      setInputError(label, true);
      return false;
    }
    if (
      typeof rule === 'object' &&
      'maxLength' in rule &&
      inputValue.length > rule.maxLength
    ) {
      setErrorMessage(`Maximum length is ${rule.maxLength}`);
      setInputError(label, true);
      return false;
    }
  }
  setErrorMessage('');
  setInputError(label, false);
  return true;
}
